import { GlobalLimits, IHasOrgId, IHasSchedule, IHasSettings, IWarehouse } from './';
import { INovaEntity, NovaId } from './base';
import type { Maybe } from './globals';
import { iEqual } from './js-helpers/str';
import { IOrg } from './org';

export enum LoadTypeDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  InOut = 'Inbound/Outbound'
}

export enum LoadTypeOperation {
  Live = 'Live',
  Drop = 'Drop',
  Other = 'Other'
}

export enum LoadTypeEquipmentType {
  DryVan = 'Dry Van',
  Flatbed = 'Flatbed',
  Reefer = 'Reefer',
  Other = 'Other'
}

export enum LoadTypeTransportationMode {
  FTL = 'FTL',
  PTL = 'PTL',
  Other = 'Other'
}

export const MAX_LOAD_TYPES_PER_WAREHOUSE = GlobalLimits.MAX_LOAD_TYPES_PER_WAREHOUSE.value;

export interface ILoadType extends INovaEntity, IHasOrgId, IHasSettings, IHasSchedule {
  name: string;
  duration_min: number;
  orgId: string;
  org?: Maybe<IOrg>;
  warehouseId?: Maybe<NovaId>;
  warehouse?: Maybe<IWarehouse>;
  direction: LoadTypeDirection;
  operation?: Maybe<LoadTypeOperation>;
  equipmentType?: Maybe<LoadTypeEquipmentType>;
  transportationMode?: Maybe<LoadTypeTransportationMode>;
  allowCarrierScheduling: boolean;
  description?: Maybe<string>;
}

export function isWarehouseLoadType(loadtype: ILoadType): boolean {
  return Boolean(loadtype.warehouseId);
}

export function getLoadtypeShortDirection(loadtype: ILoadType): string {
  if (!loadtype?.direction) {
    return '';
  }

  if (iEqual(loadtype.direction, LoadTypeDirection.Inbound)) {
    return 'IN';
  }

  if (iEqual(loadtype.direction, LoadTypeDirection.Outbound)) {
    return 'OUT';
  }

  if (iEqual(loadtype.direction, LoadTypeDirection.InOut)) {
    return 'IN/OUT';
  }

  return loadtype.direction;
}
